/* iFlip Lipa Polepole calculator — runs after iflip.js (needs window.iflipLipa) */
document.addEventListener('DOMContentLoaded', function () {
  'use strict';
  var root = document.querySelector('[data-lipa]');
  var cfgEl = document.querySelector('[data-lp-config]');
  var L = window.iflipLipa;
  if (!root || !cfgEl || !L) return;
  var cfg = JSON.parse(cfgEl.textContent);
  var $ = function (s) { return root.querySelector(s); };
  var fmt = function (n) { return cfg.currency + ' ' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); };

  var amount = $('[data-lp-amount]'), range = $('[data-lp-range]'), device = $('[data-lp-device]');
  var depBox = $('[data-lp-deposits]'), tenBox = $('[data-lp-tenure]');

  /* deposit options */
  var deps = L.deposits.length ? L.deposits : [40, 50, 60];
  depBox.innerHTML = deps.map(function (d, i) {
    var lbl = cfg.labels[String(d)] || (i === 0 ? 'Minimum Initial Deposit' : i === deps.length - 1 ? 'Lowest Monthly Installment' : 'Balanced Plan');
    return '<input type="radio" name="lp-dep" id="lp-d' + d + '" value="' + d + '"' + (i === 0 ? ' checked' : '') + '>' +
      '<label for="lp-d' + d + '" class="if-lp__opt"><strong>' + d + '%</strong><span>' + lbl + '</span></label>';
  }).join('');

  /* tenure 1-6 months */
  var tenures = Object.keys(L.markups).map(Number).filter(function (m) { return m >= 1 && m <= 12; }).sort(function (a, b) { return a - b; });
  if (!tenures.length) tenures = [1, 2, 3, 4, 5, 6];
  var pop = tenures.indexOf(L.popular) > -1 ? L.popular : tenures[0];
  tenBox.innerHTML = tenures.map(function (m) {
    return '<input type="radio" name="lp-ten" id="lp-t' + m + '" value="' + m + '"' + (m === pop ? ' checked' : '') + '>' +
      '<label for="lp-t' + m + '" class="if-lp__ten">' + m + ' Month' + (m > 1 ? 's' : '') + '<small>' + (m * 30) + ' Days</small>' + (m === L.popular ? '<em>POPULAR</em>' : '') + '</label>';
  }).join('');

  function clamp(v) { v = parseInt(v, 10) || 0; return Math.max(0, v); }
  function val(name) { var c = root.querySelector('input[name="' + name + '"]:checked'); return c ? c.value : null; }

  function update() {
    var price = clamp(amount.value);
    var dep = parseInt(val('lp-dep'), 10), months = parseInt(val('lp-ten'), 10), weekly = val('lp-freq') === 'weekly';
    var p = L.plan(price, dep, months, weekly);
    var set = function (k, v) { var el = root.querySelector('[data-lp-o="' + k + '"]'); if (el) el.textContent = v; };
    set('price', fmt(price));
    set('deposit', fmt(p.deposit) + ' (' + dep + '%)');
    set('balance', fmt(p.balance));
    set('repayable', fmt(p.repayable));
    set('inst-label', weekly ? 'Estimated weekly installment' : 'Estimated monthly installment');
    set('installment', fmt(p.installment));
    set('count', 'over ' + p.count + (weekly ? ' weekly' : ' monthly') + ' installment' + (p.count > 1 ? 's' : '') + ' · ' + months + ' month' + (months > 1 ? 's' : ''));
    set('total', fmt(p.total));
    root.querySelectorAll('[data-lp-quick] a').forEach(function (a) { a.classList.toggle('is-active', parseInt(a.getAttribute('data-v'), 10) === price); });

    var devName = device && device.value && parseInt(device.value, 10) === price ? device.options[device.selectedIndex].textContent.split(' — ')[0] : 'Device worth ' + fmt(price);
    var summary = devName + ' | Deposit ' + fmt(p.deposit) + ' (' + dep + '%) | ' + p.count + ' x ' + fmt(p.installment) + (weekly ? ' weekly' : ' monthly') + ' | Total ' + fmt(p.total);
    var h = root.querySelector('[data-lp-h-plan]'); if (h) h.value = summary;
    var wa = root.querySelector('[data-lp-wa]');
    wa.href = 'https://wa.me/' + cfg.wa + '?text=' + encodeURIComponent('Hello iFlip Store Kenya, I would like to book Lipa Polepole:\n• ' + summary.split(' | ').join('\n• '));
  }

  function setPrice(v, fromRange) {
    v = clamp(v);
    amount.value = v;
    if (!fromRange) range.value = Math.min(Math.max(v, cfg.min), cfg.max);
    update();
  }

  range.addEventListener('input', function () { if (device) device.value = ''; setPrice(range.value, true); });
  amount.addEventListener('input', function () { if (device) device.value = ''; setPrice(amount.value); });
  if (device) device.addEventListener('change', function () { if (device.value) setPrice(device.value); });
  root.addEventListener('click', function (e) {
    var q = e.target.closest('[data-lp-quick] a');
    if (q) { e.preventDefault(); if (device) device.value = ''; setPrice(q.getAttribute('data-v')); }
  });
  root.addEventListener('change', function (e) { if (/^lp-(dep|ten|freq)$/.test(e.target.name)) update(); });

  /* ?price=80000 or ?product=handle */
  var qs = new URLSearchParams(window.location.search);
  if (qs.get('product') && device) {
    var o = device.querySelector('option[data-handle="' + qs.get('product') + '"]');
    if (o) { device.value = o.value; setPrice(o.value); return; }
  }
  if (qs.get('price')) setPrice(qs.get('price')); else setPrice(amount.value);
});
